import { getCheckoutAppContextUrl } from './constants';

import { fetchV3WithTranslateServerErrors } from './base';

const getAppContext = (contextQuery) => {
    const appContextUrl = getCheckoutAppContextUrl(contextQuery);

    return fetchV3WithTranslateServerErrors({}, appContextUrl, {
        headers: { 'X-EB-App-Context': true },
    });
};

export default getAppContext;
